import { I18n, type Scope, type TranslateOptions } from "i18n-js"
import { usePage } from "@inertiajs/react"
import translations from "@/locales/translations.json"
import type { SharedProps } from "@/types"

const defaultLocale = "en"
const currentLocale = typeof document === "undefined" ? defaultLocale : document.documentElement.lang || defaultLocale

const i18n = new I18n(translations)

i18n.defaultLocale = defaultLocale
i18n.locale = currentLocale

function t(scope: Scope, options?: TranslateOptions) {
  return i18n.t(scope, options)
}

function useI18n() {
  const { locale } = usePage<SharedProps>().props

  i18n.locale = locale

  if (typeof document !== "undefined") {
    document.documentElement.lang = locale
  }

  return { i18n, t }
}

export { i18n, t, useI18n }
